import { render } from "./ElementHeader.vue?vue&type=template&id=77a61e01&scoped=true"
import script from "./ElementHeader.vue?vue&type=script&lang=js"
export * from "./ElementHeader.vue?vue&type=script&lang=js"

import "./ElementHeader.vue?vue&type=style&index=0&id=77a61e01&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a61e01"]])

export default __exports__